import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/marketing/HowWeWork.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/marketing/ProductMoment.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/marketing/RelatedServices.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/marketing/FaqBlock.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/marketing/ClosingCta.module.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/(marketing)/simulations-services/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ui/Faq.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/ui/Reveal.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
